import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import TagsToolContent from '../TagsToolContent';
import TagEditPopup from './TagEditPopup';
import useTagPopupsState from '../useTagPopupsState';
import { closePopup } from '../../../../../../components/popupPanel/popupActions';

import { TooltipAlignment } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { Tag } from '../../../../../../../common/tags/tagTypes';

import './TagsToolbarPopup.scss';

export type TagsToolbarPopupProps = {
    name: string;
    buttonSelector: string;
    alignment: TooltipAlignment;
    currentUserId: string;
    currentBoardId: string;
    selectedElements: Immutable.List<ImMNElement>;
    tag: Tag | null;
    showEditingPopup: boolean;
    shareRootPath: Array<ImMNElement>;
    userRootPath: Array<ImMNElement>;
    handleClickEdit: (tag: Tag) => void;
    closePopup: () => void;
};

const TagsToolbarPopup: React.FC<TagsToolbarPopupProps> = (props) => {
    const { buttonSelector } = props;

    const [showEditingPopup, setShowEditingPopup] = useState<boolean>(false);
    const openEditingPopup = () => {
        setShowEditingPopup(true);
    };

    const { currentlyEditingTag, shareRootPath, userRootPath, handleClickEdit, setCurrentlyEditingTag } =
        useTagPopupsState(openEditingPopup);

    const dispatch = useDispatch();
    const dismissPopup = () => {
        dispatch(closePopup(PopupIds.TAGS_TOOL));
        setShowEditingPopup(false);
        setCurrentlyEditingTag(null);
    };

    return (
        <ToolbarPopup
            buttonSelector={buttonSelector}
            alignment={TooltipAlignment.CENTER}
            popupId={PopupIds.TAGS_TOOL}
            className={classNames('TagsPopup')}
            showArrow={false}
        >
            <TagsToolContent
                {...props}
                handleClickEdit={handleClickEdit}
                shareRootPath={shareRootPath}
                userRootPath={userRootPath}
            />
            {showEditingPopup && (
                <TagEditPopup
                    {...props}
                    tag={currentlyEditingTag}
                    showEditingPopup={showEditingPopup}
                    shareRootPath={shareRootPath}
                    handleClickEdit={handleClickEdit}
                    closePopup={dismissPopup}
                />
            )}
        </ToolbarPopup>
    );
};

export default TagsToolbarPopup;
